// app/javascript/projects/components/ProjectsDisplay.jsx

import React, { useEffect, useMemo } from 'react';
import { useHistory, useParams, useLocation } from 'react-router-dom';
import { useSubscription } from '../../hooks/subscriptions/queries';
import { useProjects } from '../../hooks/projects/queries';
import { useCurrentUser } from '../../hooks/users/queries';
import { useProject } from '../../hooks/projects/queries';
import { isProjectOwner } from '../../utils/projectUtils';
import { isCancelled } from '../../utils/subscriptionUtils';
const queryString = require('query-string');

function SubscriptionModal() {
  const history = useHistory();
  const location = useLocation();
  const { projectID } = useParams();
  const { data: subscription, isLoading: subscriptionLoading } = useSubscription();
  const { data: projectsData, isLoading: projectsLoading } = useProjects();
  const { data: currentUser, isLoading: userLoading } = useCurrentUser();
  const { data: project } = useProject(projectID);

  const projectLoaded = !projectsLoading && !!projectsData;
  const userLoaded = !userLoading && !!currentUser;
  const subscriptionCancelled = isCancelled(subscription);
  
  // Calculate hasShared only when data is loaded
  const hasShared = (projectLoaded && userLoaded && projectsData?.projects) 
    ? projectsData.projects.some(proj => !isProjectOwner(proj, currentUser))
    : false;

  // Use useEffect to handle the redirect - MUST be called before any returns
  useEffect(() => {
    // Don't do anything while data is still loading
    if (subscriptionLoading || projectsLoading || userLoading) {
      return;
    }
    
    // Priority 1: If no subscription and no shared projects, redirect to intro survey
    if (!subscription && !hasShared) {
      // Check if we're already on the intro_survey page to avoid redirect loops
      if (location.pathname === '/intro_survey') {
        return;
      }
      console.log('Redirecting to intro_survey - no subscription and no shared projects');
      // Preserve promo parameter when redirecting
      history.push('/intro_survey');
      return;
    }
    
    // Priority 2: If view-only or cancelled subscription, redirect to codes page
    // Only redirect from pages that require an active subscription (search, analysis, chat, new transcript/survey)
    if (project && projectID && (project.role === 'view_only' || subscriptionCancelled)) {
      const path = location.pathname;
      const isRestrictedPage = path.includes('/search') ||
                               path.includes('/analysis') ||
                               path.includes('/chat') ||
                               path.includes('/transcripts/new') ||
                               path.includes('/surveys/new');

      if (isRestrictedPage) {
        const codesPath = `/projects/${projectID}/codes`;
        // Check if we're already on the codes page to avoid redirect loops
        if (path === codesPath) {
          return;
        }
        console.log('Redirecting to codes page - view-only or cancelled subscription');
        history.push(codesPath);
      }
    }
  }, [subscriptionLoading, projectsLoading, userLoading, projectLoaded, userLoaded, subscription, hasShared,
      subscriptionCancelled, project, projectID, location.pathname, history]);

  return <></>;
}

export default SubscriptionModal;